import EmptyState from "@components/common/loading/EmptyState";
import { useAuth } from "@hooks";
import { useNavigate } from "react-router-dom";

import TemplateCTABanner from "./TemplateCTABanner";
import EmptyStateImg from "../../../assets/imgs/template-empty-state.svg";

const ErrorState = () => {
  const { isUserAuthenticated } = useAuth();
  const navigate = useNavigate();
  const handleSignIn = () => {
    navigate("/auth/login");
  };
  const handleSignUp = () => {
    navigate("/auth/register");
  };
  return (
    <>
      <EmptyState
        img={EmptyStateImg}
        title="You don't have access to this template."
        description={
          isUserAuthenticated
            ? "Please contact the owner of the template to request access."
            : "If you think you should have access, please sign in and try again."
        }
      />
      {isUserAuthenticated ? null : (
        <TemplateCTABanner
          handleSignIn={handleSignIn}
          handleSignUp={handleSignUp}
          title="Want to use this template?"
          description="Your friend wants to share this template with you, but you need a Scribenote account to access it. Sign in or create a free account to get started, and start saving hours each week on your veterinary notes!"
        />
      )}
    </>
  );
};

export default ErrorState;
